var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDistrubutorInactiveIcon = function SvgDistrubutorInactiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M12.292 16.875h4.583v-4.583M16.875 7.708V3.125h-4.583M10 10H3.125M10 10l6.25 6.25M10 10l6.25-6.25"
  })));
};
export { SvgDistrubutorInactiveIcon as ReactComponent };
export default __webpack_public_path__ + "a38fa11541be10336309fe686ce629ba.svg";